import React from 'react';

import { Tag } from 'antd';
import type { IntlShape } from 'react-intl';

import type { IWorkJourneyManagementUser } from '@src/models/interfaces/workJourneyManagement.interface';

import { getCoverPickerRowKey } from '../../WorkJourneyManagement/components/CoverPositionDrawers/coverPickerRowKey';
import type { AttendanceStatusDisplay } from './attendanceStatus/types';

/** Renders an attendance status Tag; returns null when status is missing. */
export const renderAttendanceStatusTag = (
  intl: IntlShape,
  status?: AttendanceStatusDisplay | null,
): React.ReactNode => {
  if (!status) {
    return null;
  }
  return (
    <Tag color={status.color} className="gx-mb-0 gx-mr-0">
      {intl.formatMessage({ id: status.labelId })}
    </Tag>
  );
};

export const createAttendanceStatusRenderer =
  (intl: IntlShape, statusByRecordId: Map<string, AttendanceStatusDisplay>) =>
  (user: IWorkJourneyManagementUser): React.ReactNode =>
    renderAttendanceStatusTag(intl, statusByRecordId.get(getCoverPickerRowKey(user)));
